import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.component.html",
  styleUrls: ["./about-us.component.css"],
})
export class AboutUsComponent implements OnInit {
  constructor(public router: Router) {}

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
  }
}
